// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import Accordion from '~/components/Modules/Accordion';
import { ConstructBasicElement, GetCopyFromJson } from '~/contentstack/rendering';

import './FAQSection.scss';

export const query = graphql`
	fragment FAQSectionFragment on Ozk_content_blockModular_blocksCopyContent {
		faq {
			heading {
				json
			}
			items {
				title
				copy {
					json
				}
			}
			non_faq_items {
				copy {
					json
				}
			}
		}
	}
`;

/**
 * @typedef FAQItem
 * @property {string} title
 * @property {import('../CSTypes').CSJRTE} copy
 *
 * @typedef NonFAQItem
 * @property {import('../CSTypes').CSJRTE} copy
 *
 * @typedef FAQOptions
 * @property {import('../CSTypes').CSJRTE} heading
 * @property {FAQItem[]} items
 * @property {NonFAQItem[]} [non_faq_items]
 *
 * @typedef FAQSectionProps
 * @property {FAQOptions} options
 */
/** @type {import('~/types/React').ReactFC<FAQSectionProps>} */
const FAQSection = ({ options }) => {
	return (
		<div className="faq-section">
			{GetCopyFromJson(options.heading, ConstructBasicElement('p', 'h4'))}

			<Accordion className="faq-accordion">
				{options.items.map((item, i) => (
					<div className="faq-item" title={item.title} key={i}>
						{GetCopyFromJson(item.copy)}
					</div>
				))}
			</Accordion>

			{/* Add the non_faq_copy after the accordion */}
			<React.Fragment>{options.non_faq_items.map((nonItem) => GetCopyFromJson(nonItem.copy))}</React.Fragment>
		</div>
	);
};

export default FAQSection;
